<template>
	<main :class="$style.home">
		<article :class="$style.editors">
			<div role="tablist">
				<button
					v-for="(tab, index) in tabs"
					:id="`tabid-${tab}`"
					:key="tab"
					:aria-controls="tab"
					:aria-selected="activeTab === tab ? 'true' : 'false'"
					:class="$style.steps"
					:data-index="index + 1"
					role="tab"
					type="button"
					@click="loadTab($event)"
				>
					{{ tab }}
				</button>
			</div>
			<Ace
				v-show="activeTab === 'Content'"
				id="Content"
				key="content"
				aria-labelledby="tabid-Content"
				focus
				mode="markdown"
				ref-node="md"
				role="tabpanel"
				@content-change="handleContentChange"
			/>
			<Ace
				v-show="activeTab === 'Style'"
				id="Style"
				key="style"
				:default-content="css"
				aria-labelledby="tabid-Style"
				mode="css"
				ref-node="css"
				role="tabpanel"
				@content-change="handleContentChange"
			/>
			<Settings v-show="activeTab === 'Settings'" key="settings" />
		</article>
		<Preview />
	</main>
</template>

<script>
import Ace from '@/components/Ace'
import Preview from '@/components/Preview'
import Settings from '@/components/Settings'
import editorState from '@/store/editorState'
import { clearRafTimeout, setRafTimeout } from '@/utils/rafTimeout'
import { computed, reactive, ref, watch } from '@vue/composition-api'

export default {
	name: 'Home',
	components: {
		Ace,
		Preview,
		Settings,
	},
	setup() {
		const { getCss, loadHtml } = editorState
		const activeTab = ref('Content')
		const css = ref('')
		const md = ref('')
		const merge = ref(null)
		const tabs = ['Content', 'Style', 'Settings']
		const timer = reactive({ raf: null })

		const handleContentChange = editor => {
			if (editor.mode === 'markdown') {
				md.value = editor.content.trim() || ''
			}

			if (editor.mode === 'css') {
				css.value = editor.content.trim() || ''
			}

			merge.value = { css: css.value, md: md.value }
		}

		const loadTab = e => {
			activeTab.value = e.target.innerText.trim()
		}

		const mergeWatch = watch(merge, async merge => {
			if (typeof merge === 'object') {
				clearRafTimeout(timer.raf)
				timer.raf = setRafTimeout(async () => {
					await loadHtml({ html: merge })
				}, 333)
			}
		})

		return {
			Ace,
			activeTab,
			css: computed(() => getCss).value,
			handleContentChange,
			loadTab,
			mergeWatch,
			tabs,
		}
	},
}
</script>

<style lang="less" module>
.home {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: none;
	min-height: 100vh;
	overflow: hidden;

	@media screen and (max-width: 769px) {
		grid-template-columns: none;
		grid-template-rows: 0.5fr 1fr;
	}
}

.editors {
	display: grid;
	grid-template-rows: minmax(42px, 42px) 1fr;
}

.steps {
	&::before {
		content: attr(data-index) + '.';
		margin-right: #theme.spacing[s];
	}
}
</style>
